/**
 * Bilgi bankası read model (GET /kb, v0.1.23): every knowledge entry with its products and
 * sources. Drafts wait for Sercan; only approved entries reach the Temsilci.
 */

import type { KbEntry, KbStatus, KbView } from '@twin/contracts';

export type { KbEntry, KbProductRef, KbStatus, KbView } from '@twin/contracts';

export const KB_STATUS_LABELS: Readonly<Record<KbStatus, string>> = Object.freeze({
  draft: 'Taslak',
  approved: 'Onaylı',
  conflict: 'Çelişki',
  retired: 'Emekli',
});

export const PRODUCT_STATUS_LABELS: Readonly<Record<string, string>> = Object.freeze({
  active: 'Etsy’de listeli',
  inactive: 'İlan pasif',
  draft: 'Envanter',
  retired: 'Kaldırıldı',
});

/** A short Turkish name for a source record of an entry. */
export function sourceLabel(source: Readonly<Record<string, unknown>>): string {
  const kind = typeof source.kind === 'string' ? source.kind : '';
  switch (kind) {
    case 'document':
      return typeof source.title === 'string'
        ? `${source.title}${typeof source.ref === 'string' ? ` ${source.ref}` : ''}`
        : 'Belge';
    case 'etsy_listing':
      return `Etsy ilanı ${typeof source.listingId === 'number' || typeof source.listingId === 'string' ? source.listingId : ''}`.trim();
    case 'r2_file':
      return typeof source.key === 'string' ? `Dosya: ${source.key.split('/').pop() ?? source.key}` : 'Dosya';
    default:
      return kind === '' ? 'Kaynak' : kind;
  }
}

/** The link of a source when it has one (Etsy listings). */
export function sourceUrl(source: Readonly<Record<string, unknown>>): string | null {
  return typeof source.url === 'string' && source.url.startsWith('https://') ? source.url : null;
}

export function countsOf(entries: readonly KbEntry[]): KbView['counts'] {
  const counts = { draft: 0, approved: 0, conflict: 0, retired: 0 };
  for (const entry of entries) counts[entry.status] += 1;
  return counts;
}
